export const ProjectName = (projectId: string | number | null | undefined) => {

  if (projectId == null || projectId === undefined) {
    return '';
  }

  switch (projectId.toString().toLocaleLowerCase()) {
    case 'ppk':
    case 'ppf':
    case 'pingpongfury':
    case '1':
      return 'Ping Pong Fury';
    case 'dof':
    case 'dartsoffury':
    case'darts':
    case '4':
      return 'Darts of Fury';
    case 'ykt-bowl':
    case 'bowling':
    case '5':
      return 'Bowling Fury';
    case 'ttt':
    case 'tabletennistouch':
      return 'Table Tennis Touch';
    case 'prototype':
      return 'Prototype';

    default:
      return projectId.toString().toLocaleUpperCase();
  }

};
